<div class="flex flex-col gap-8">
  <!-- Header with progress -->
  <div class="flex flex-col gap-2">
    @if (purpose()) {
      <span class="text-sm font-medium tracking-wide text-neutral-10 uppercase">
        {{ purpose() }}
      </span>
    }
    <span class="text-sm font-medium tracking-wide text-neutral-10 uppercase">
      Étape {{ currentStepIndex() + 1 }} sur {{ steps().length }}
    </span>
    <div class="h-1 w-full overflow-hidden rounded-full bg-neutral-3">
      <div
        class="h-full bg-primary-9 transition-all duration-300 ease-out"
        [style.width.%]="((currentStepIndex() + 1) / steps().length) * 100"
      ></div>
    </div>
  </div>

  <!-- Vertical steps list (Desktop) -->
  <div class="relative ml-4 hidden flex-col lg:flex">
    @for (step of steps(); track step.label; let i = $index; let isFirst = $first; let isLast = $last) {
      <div
        role="button"
        tabindex="0"
        class="step-item group relative flex min-h-[48px] cursor-pointer items-center py-3 pl-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-9 focus-visible:ring-offset-2 focus-visible:rounded-xl"
        [class.active]="i === currentStepIndex()"
        [class.completed]="step.completed"
        (click)="onStepClick(i)"
        (keydown.enter)="onStepClick(i)"
        (keydown.space)="$event.preventDefault(); onStepClick(i)"
      >
        <!-- Background Rail Segment -->
        <div
          class="absolute left-0 w-[2px] bg-neutral-3"
          [style.top]="isFirst ? '50%' : '0'"
          [style.bottom]="isLast ? '50%' : '0'"
        ></div>

        <!-- Blue path segment -->
        @if (i <= currentStepIndex() || step.completed) {
          <div
            class="absolute left-0 z-10 w-[2px] bg-primary-9 transition-all duration-300"
            [style.top]="isFirst ? '50%' : '0'"
            [style.bottom]="isLast ? '50%' : '0'"
          ></div>
        }

        <!-- Active step highlight (Glow) -->
        @if (i === currentStepIndex()) {
          <div
            class="absolute inset-y-1 right-0 left-0 -z-10 rounded-xl bg-primary-2/20 blur-sm transition-all duration-300"
          ></div>
        }

        <!-- Dot on the line -->
        <div
          class="step-dot surface-default absolute top-1/2 -left-[13px] z-20 flex h-7 w-7 items-center justify-center rounded-full border-2 transition-all duration-300"
          [class.border-primary-9]="i <= currentStepIndex() || step.completed"
          [class.bg-primary-9]="step.completed"
          [class.border-neutral-6]="i > currentStepIndex() && !step.completed"
        >
          <!-- Checkmark for completed -->
          @if (step.completed) {
            <mat-icon class="scale-75 text-white">check</mat-icon>
          } @else if (i === currentStepIndex()) {
            <div class="h-2 w-2 animate-pulse rounded-full bg-primary-9"></div>
          }
        </div>

        <!-- Label -->
        <span
          class="step-label block text-sm font-semibold transition-colors duration-200"
          [class.text-primary-9]="i === currentStepIndex()"
          [class.text-neutral-10]="step.completed && i !== currentStepIndex()"
          [class.text-neutral-6]="i > currentStepIndex() && !step.completed"
        >
          {{ step.label }}
        </span>
      </div>
    }
  </div>
</div>
